import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { UserService } from '@services/user.service';
import { CategoryResponse, ChangedCategories } from '../models/index';
import { RequestsUtilityService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class CategoriesApiService {
  private http = inject(HttpClient);
  private userService = inject(UserService);
  private requestsUtilityService = inject(RequestsUtilityService);

  private options = {
    headers: this.requestsUtilityService.bearerToken(
      this.userService.user.token,
    ),
  };

  public getCategoriesList(): Observable<CategoryResponse> {
    const url = `categories/categories-with-weights`;
    return this.http.get<CategoryResponse>(
      `${environment.triviaRushApiUrl}${url}`,
      this.options,
    );
  }

  public saveCategories(
    changedData: ChangedCategories,
  ): Observable<{ message: string }> {
    const url = `categories/weights`;
    return this.http.patch<{ message: string }>(
      `${environment.triviaRushApiUrl}${url}`,
      changedData,
      this.options,
    );
  }
}
